import { FormFieldTypes } from '@/types/types';
import { useTranslation } from 'react-i18next';
import { useNav, useOtpVerifyManager } from '@hero/web-hooks';
import { CustomFormField } from '@hero/web-components';
import { Spinner } from '@hero/web-components';
import { Button } from '@hero/web-components';
import { Form } from '@hero/web-components';

const OtpForm = () => {
  const { t } = useTranslation();
  const { navigate } = useNav();
  const { form, isPending, isResend, onSubmit, handleResend, countdown } = useOtpVerifyManager({
    // Keep SPA navigation instead of the manager's hard-redirect default.
    onExistingUser: () => navigate('dashboard'),
  });

  return (
    <Form {...form}>
      <form onSubmit={onSubmit} className="w-full mt-6">
        <div className="flex justify-center" style={{ direction: 'ltr' }}>
          <CustomFormField
            control={form.control}
            filedType={FormFieldTypes.PHONE_OTP}
            name="code"
          />
        </div>

        <Button
          type="submit"
          disabled={isPending}
          className="w-full mt-8 h-13 rounded-[32px] text-[16px] leading-[26px] font-[500]">
          {isPending ? <Spinner /> : t('registration:otp.otbBtn')}
        </Button>

        <p
          className={`mt-6 text-center text-gray-500 ${countdown === 0 ? 'cursor-pointer' : ''}`}
          onClick={countdown === 0 ? handleResend : undefined}>
          {countdown > 0 ? (
            <span>
              {t('registration:otp.receive')}{' '}
              {isResend ? (
                'Loading...'
              ) : (
                <span className="font-semibold text-logoBlue">{countdown}s</span>
              )}{' '}
            </span>
          ) : (
            <span>
              {t('registration:otp.receive')}{' '}
              {isResend ? (
                'Loading...'
              ) : (
                <span className="font-semibold text-logoBlue">{t('registration:otp.resend')}</span>
              )}
            </span>
          )}
        </p>
      </form>
    </Form>
  );
};

export default OtpForm;
